export const TASTING_NOTE_PLACEHOLDERS: string[] = [
  'What did you taste? e.g. Bright citrus, honey sweetness, clean finish',
  'How would you describe the flavor? e.g. Dark chocolate, toasted walnut, caramel',
  'What stood out in this cup? e.g. Juicy blueberry, floral aroma, winey finish',
  'Any tasting notes to share? e.g. Smooth vanilla, brown sugar, creamy body',
  'What flavors did you pick up? e.g. Stone fruit, jasmine, silky mouthfeel',
  'How did it taste? e.g. Tart cherry, molasses, lingering spice',
  'What would you say about this coffee? e.g. Tropical mango, graham cracker, buttery',
  'Describe your experience? e.g. Crisp apple, cinnamon, delicate sweetness',
  'Notice any interesting flavors? e.g. Blackberry jam, cocoa nib, velvety finish',
  'What comes to mind? e.g. Lemon zest, toasted almond, bright and balanced',
];

export function getRandomTastingNotePlaceholder(): string {
  const index = Math.floor(Math.random() * TASTING_NOTE_PLACEHOLDERS.length);
  const fallback: string = TASTING_NOTE_PLACEHOLDERS[0] ?? '';
  return TASTING_NOTE_PLACEHOLDERS[index] ?? fallback;
}
